module.exports = [{
      plugin: require('C:/Users/William/workspace/gatsby-blog/node_modules/gatsby-plugin-google-analytics/gatsby-browser'),
      options: {"plugins":[]},
    },{
      plugin: require('C:/Users/William/workspace/gatsby-blog/node_modules/gatsby-plugin-offline/gatsby-browser'),
      options: {"plugins":[]},
    }]
